<template>
    <div v-loading="loading">
        <div class="card">
            <div class="card-body" style="padding: 0;">
                <soft-button v-if="hasCourtReadyParticipants" style="margin-left: 5px; margin-top: 5px;"
                    class="btn bg-gradient-success mb-2" type="button" @click="openCourtDialog">
                    <i class="fa fa-plus me-1"></i> Yeni məhkəmə işi
                </soft-button>

                <court-dialog v-model="courtDialogVisible" :subrogation-id="subrogationId" @saved="fetchCourtCases" />

                <el-collapse v-if="courtCases.length > 0" v-model="activeCollapse" class="mt-3">
                    <el-collapse-item v-for="(caseItem) in courtCases" :key="caseItem.id" :name="caseItem.id">
                        <template #title>
                            <titles :text="`Məhkəmə işi №${caseItem.courtCaseNumber}`" />
                        </template>
                        <hr style="margin-top: 0; margin-bottom: 15px;" />
                        <div class="position-relative rounded p-3" style="color: #606266; font-size: 14px;">
                            <el-button class="bg-white shadow-none p-0 position-absolute top-0 end-0 mt-2 me-2 fs-5"
                                type="text" style="padding: 0px;" :icon="Edit" title="Düzəliş et" size="large"
                                :disabled="lastStatus === 50" @click="editCourt(caseItem)">
                            </el-button>
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="row mb-2">
                                        <div class="col-4 font-weight-bold">Məhkəmə</div>
                                        <div class="col-8">{{ getCourtNameById(caseItem.courtId) }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-4 font-weight-bold">Ünvan</div>
                                        <div class="col-8">{{ getCourtAddressById(caseItem.courtId) }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-4 font-weight-bold">Hakim</div>
                                        <div class="col-8">{{ caseItem.judge }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-4 font-weight-bold">İcraçı</div>
                                        <div class="col-8">{{ caseItem.executor || '-' }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-4 font-weight-bold">Əlaqə nömrəsi (İcraçı)</div>
                                        <div class="col-8">{{ caseItem.executorPhone }}</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row mb-2">
                                        <div class="col-4 font-weight-bold">Məhkəməyə qədər xərclər (AZN)</div>
                                        <div class="col-8">
                                            {{ caseItem.preCourtExpense !== null && caseItem.preCourtExpense !==
                                                undefined ?
                                                formatAmount(caseItem.preCourtExpense) : "—" }}
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-4 font-weight-bold">Tələb olunan məbləğ (AZN)</div>
                                        <div class="col-8">
                                            {{ caseItem.demandedAmount !== null && caseItem.demandedAmount !== undefined
                                                ?
                                                formatAmount(caseItem.demandedAmount) : "—" }}
                                        </div>
                                    </div>

                                    <div class="row mb-2">
                                        <div class="col-4 font-weight-bold">Məsul şəxs</div>
                                        <div class="col-8">{{ responsibleUserName || "-" }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-4 font-weight-bold">Tarix</div>
                                        <div class="col-8">{{ DateToString(caseItem.createDate) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-3" style="margin-left:5px">
                            <button type="button" class="btn btn-outline-info" @click="openAccusedDialog(caseItem.id)">
                                <i class="fa fa-user-plus me-1"></i> Cavabdeh əlavə et
                            </button>
                        </div>
                        <div class="mt-4">
                            <div class="row">
                                <div v-for="person in caseItem.participants" :key="person.id" class="col-md-6 mb-3">
                                    <participant-card :person="person" :show-delete="true"
                                        @edit="(person) => editParticipant(person, caseItem.id)"
                                        @delete="(person) => deleteCourtParticipant(person.id, caseItem.id)" />
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <div class="row">
                                <div class="col-md-6 d-flex flex-column gap-4">
                                    <div class="card mb-4 w-100 shadow-sm border border-light">
                                        <div class="card-body px-4 py-3">
                                            <titles text="İclaslar" />
                                            <hr class="my-2">
                                            <button type="button" class="btn bg-gradient-success"
                                                @click="openHearingDialog(caseItem.id)">
                                                <i class="fa fa-plus font-weight-bold"></i>&nbsp;&nbsp;Yeni yazı
                                            </button>
                                            <court-hearings-table :hearings="caseItem.hearings"
                                                :loading="loadingHearings" @edit-hearing="editHearing"
                                                @delete-court-hearing="(id) => confirmDeleteHearing(caseItem.id, id)" />
                                            <el-dialog v-model="hearingDialogVisible" width="30%" title="Yeni iclas"
                                                @close="hearingDialogVisible = false">
                                                <court-hearing-dialog :court-case-id="selectedCourtCaseId"
                                                    :hearing-to-edit="hearingToEdit" @saved="onHearingSaved"
                                                    @cancel="hearingDialogVisible = false" />
                                            </el-dialog>
                                        </div>
                                    </div>
                                    <court-decision-card :case-item="caseItem"
                                        :open-decision-dialog="openDecisionDialog"
                                        @refresh-enforcements="loadCourtsAndCases"
                                        @refresh-enforcement-tab="onRefreshEnforcement" />
                                </div>
                                <div class="col-md-6 d-flex flex-column gap-4">
                                    <div class="card mb-4 w-100 shadow-sm border border-light">
                                        <div class="card-body px-4 py-3">
                                            <titles text="Məhkəmə xərcləri" />
                                            <hr class="my-2">
                                            <button type="button" class="btn bg-gradient-success"
                                                @click="openExpenseDialog(caseItem.id)">
                                                <i class="fa fa-plus font-weight-bold"></i>&nbsp;&nbsp;Yeni yazı
                                            </button>
                                            <court-expenses-table :expenses="caseItem.expenses"
                                                :reason-list="reasonList" :loading="loadingExpenses" :status="status"
                                                @edit-expense="editExpense"
                                                @delete-expense="(id) => confirmDeleteExpense(caseItem.id, id)" />
                                            <el-dialog v-model="expenseDialogVisible" width="30%" title="Yeni xərc"
                                                @close="resetExpenseForm">
                                                <court-expense-dialog :key="expenseToEdit ? expenseToEdit.id : 'new'"
                                                    :court-case-id="selectedCourtCaseId"
                                                    :expense-to-edit="expenseToEdit" :reason-list="reasonList"
                                                    @saved="onExpenseSaved" @cancel="resetExpenseForm" />
                                            </el-dialog>

                                        </div>
                                    </div>
                                    <div class="card shadow-sm border border-light">
                                        <div class="card-body">
                                            <titles text="Sənədlər" />
                                            <hr style="margin-top: 0; margin-bottom: 15px;" />
                                            <div v-for="doc in caseItem.documents" :key="doc.id || doc.documentName"
                                                class="mb-3">
                                                <div class="doc-header-row">
                                                    <upload class="upload-root" :sourcetype="1" :source-id="doc.id"
                                                        :document-name="doc.documentName" :listtype="'text'"
                                                        :disabled="false" :downloadAll="false"
                                                        @filesloaded="() => loadSubrogationDocs(caseItem.id)"
                                                        :showTrigger="true" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>

        <el-dialog v-model="editCourtDialogVisible" title="Məhkəmə işi - Düzəliş" width="35%">
            <edit-court-dialog :value="editableCourtForm" :courts="courts" />
            <div class="d-flex justify-content-end mt-4">
                <soft-button @click="saveCourtEdit">Yadda saxla</soft-button>
                &nbsp;
                <soft-button color="secondary" @click="editCourtDialogVisible = false">İmtina</soft-button>
            </div>
        </el-dialog>

        <el-dialog v-model="accusedDialogVisible" title="Yeni cavabdeh" width="30%" top="70px">
            <CourtAccusedDialog :participants="participants"
                v-model:selected-participant-id="selectedParticipantId" @save="saveAccused"
                @cancel="accusedDialogVisible = false" />
        </el-dialog>

        <el-dialog v-model="openRespDialog" title="Cavabdeh şəxs - Düzəliş" width="50%" top="70px">
            <div class="card-body pt-0">
                <div class="row">
                    <div class="d-flex align-items-center" style="width: 48%;">
                        <el-input v-if="personType === 1" v-model="pinSearch" size="large" placeholder="FİN daxil edin"
                            :disabled="!hasPin" clearable style="flex: 1;">
                            <template #prefix>
                                <div class="d-flex align-items-center"
                                    style="border-right: 1px solid #dcdfe6; padding-right: 8px; margin-right: 8px;">
                                    <el-switch v-model="hasPin" size="large" active-text="Rezident"
                                        inactive-text="Qeyri-rezident" inline-prompt
                                        style="--el-switch-on-color: #28a745; --el-switch-off-color: #dc3545;" />
                                </div>
                            </template>
                        </el-input>
                        <el-input v-if="personType === 2" v-model="voenSearch" size="large"
                            placeholder="VÖEN daxil edin" :disabled="!isLegalSearchActive" clearable style="flex: 1;">
                            <template #prefix>
                                <div class="d-flex align-items-center"
                                    style="border-right: 1px solid #dcdfe6; padding-right: 8px; margin-right: 8px;">
                                    <el-switch v-model="isLegalSearchActive" size="large" active-text="Rezident"
                                        inactive-text="Qeyri-rezident" inline-prompt
                                        style="--el-switch-on-color: #28a745; --el-switch-off-color: #dc3545;" />
                                </div>
                            </template>
                        </el-input>
                        <soft-button type="button" color="info" class="ms-2"
                            style="padding: 10px 16px; min-width: 48px;" :disabled="personType === 1 && !hasPin"
                            @click="searchRespPerson">
                            <i class="fa fa-search"></i>
                        </soft-button>
                    </div>

                    <div class="col-md-12 mt-3">
                        <el-radio-group v-model="personType" size="large">
                            <el-radio :value="1">Fiziki şəxs</el-radio>
                            <el-radio :value="2">Hüquqi şəxs</el-radio>
                        </el-radio-group>
                    </div>

                    <div v-if="personType === 1" class="row w-100">
                        <div class="col-md-6 mt-3">
                            <label class="form-label">FİN</label>
                            <el-input v-model="respForm.pin" size="large" :disabled="hasPin" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Cins</label>
                            <el-select v-model="respForm.gender" size="large" placeholder="Seçin" style="width: 100%;"
                                :disabled="hasPin">
                                <el-option label="Kişi" :value="1" />
                                <el-option label="Qadın" :value="2" />
                            </el-select>
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Ad</label>
                            <el-input v-model="respForm.name" size="large" :disabled="hasPin" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Əlaqə nömrəsi</label>
                            <el-input v-model="respForm.mobilePhone" v-mask="'+994 (##) ###-##-##'" size="large"
                                placeholder="+994-(##)-123-45-66" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Soyad</label>
                            <el-input v-model="respForm.surname" size="large" :disabled="hasPin" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Əlavə əlaqə nömrəsi</label>
                            <el-input v-model="respForm.additionalMobilePhone" v-mask="'+994 (##) ###-##-##'"
                                size="large" placeholder="+994-(##)-123-45-66" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Ata adı</label>
                            <el-input v-model="respForm.fatherName" size="large" :disabled="hasPin" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">İş yeri</label>
                            <el-input v-model="respForm.workplace" size="large" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Doğum tarixi</label>
                            <el-date-picker v-model="respForm.dateOfBirth" size="large" placeholder="Seçin" type="date"
                                format="DD.MM.YYYY" value-format="YYYY-MM-DD" style="width: 100%;" :disabled="hasPin" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Faktiki yaşayış ünvanı</label>
                            <el-input v-model="respForm.regAddress" size="large" />
                        </div>
                    </div>

                    <div v-if="personType === 2" class="row w-100">
                        <div class="col-md-6 mt-3">
                            <label class="form-label">VÖEN</label>
                            <el-input v-model="respForm.tin" size="large" :disabled="isLegalSearchActive" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Faktiki yaşayış ünvanı</label>
                            <el-input v-model="respForm.regAddress" size="large" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Ad</label>
                            <el-input v-model="respForm.name" size="large" :disabled="isLegalSearchActive" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Mobil nömrə</label>
                            <el-input v-model="respForm.mobilePhone" size="large" placeholder="+994-(##)-123-45-66" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Nümayəndə</label>
                            <el-input v-model="respForm.representative" size="large" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Əlavə nömrə</label>
                            <el-input v-model="respForm.additionalMobilePhone" size="large"
                                placeholder="+994-(##)-123-45-66" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row dialog-btn mt-4">
                <div class="d-flex justify-content-end">
                    <soft-button type="button" @click="updateRespPerson">
                        Yadda saxla
                    </soft-button>
                    &nbsp;
                    &nbsp;
                    <soft-button type="button" color="secondary" @click="openRespDialog = false">
                        İmtina
                    </soft-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog v-model="decisionDialogVisible" :title="decisionForm?.id ? 'Qərar - Düzəliş' : 'Yeni Qərar'"
            width="35%" @close="resetDecisionForm">
            <CourtDecisionDialog v-model="decisionForm" />
            <div class="d-flex justify-content-end mt-4">
                <soft-button type="button" @click="saveDecision">Yadda saxla</soft-button>
                &nbsp;
                &nbsp;
                <soft-button type="button" color="secondary" @click="decisionDialogVisible = false">İmtina</soft-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Titles from "@/project/Components/Titles.vue";
import SoftButton from "@/components/SoftButton.vue";
import { GetParticipants } from "@/project/Source/participants";
import CourtDialog from "@/project/Court/Components/Dialogs/CourtDialog.vue";
import ParticipantCard from "@/project/Components/ParticipantCard.vue";
import { GetCourtCases, UpdateCourtCase } from "@/project/Source/courts";
import { CreateCourtParticipant, UpdateCourtParticipant, GetCourtParticipants, DeleteCourtParticipant } from "@/project/Source/courtparticipants";
import CourtDecisionDialog from "@/project/Court/Components/Dialogs/CourtDecisionDialog.vue";
import { CreateCourtDecision, GetCourtDecision } from "@/project/Source/courtdecisions";
import { DeleteCourtHearing, GetCourtHearings } from "@/project/Source/courthearings";
import CourtHearingDialog from "@/project/Court/Components/Dialogs/CourtHearingsDialog.vue";
import CourtHearingsTable from "@/project/Court/Components/Tables/CourtHearingsTable.vue";
import { GetSubrogationById } from "@/project/Source/subrogations";
import { respUsers, DateToString } from "@/project/Source/helper";
import { GetCourts, GetExpenseReasons } from "@/project/Source/classifiers";
import CourtDecisionCard from "@/project/Court/Components/CourtDecisionCard.vue";
import { GetCourtEnforcementsByCourtCase } from "@/project/Source/courtenforcements";
import CourtExpenseDialog from "@/project/Court/Components/Dialogs/CourtExpenseDialog.vue";
import CourtExpensesTable from "@/project/Court/Components/Tables/CourtExpensesTable.vue";
import { GetCourtExpensesByCase, DeleteCourtExpense } from "@/project/Source/expenses";
import { respPersonData } from "@/project/Source/helper";
import { mask } from "vue-the-mask";
import { Edit } from "@element-plus/icons-vue";
import { GetSubrogationDocs } from "@/project/Source/subrogationdoc";
import Upload from "@/project/Components/Upload.vue";
import EditCourtDialog from "@/project/Court/Components/Dialogs/EditCourtDialog.vue";
import CourtAccusedDialog from "@/project/Court/Components/Dialogs/CourtAccusedDialog.vue";

export default {
    directives: {
        mask,
    },
    components: {
        Upload,
        Titles,
        SoftButton,
        CourtDialog,
        ParticipantCard,
        CourtDecisionDialog,
        CourtHearingsTable,
        CourtHearingDialog,
        CourtDecisionCard,
        CourtExpenseDialog,
        CourtExpensesTable,
        EditCourtDialog,
        CourtAccusedDialog
    },
    props: {
        subrogationId: {
            type: [String, Number],
            required: true
        },
        onRefreshEnforcement: Function
    },
    emits: ['court-ready', 'saved'],
    data() {
        return {
            Edit,
            loading: false,
            courtDialogVisible: false,
            accusedDialogVisible: false,
            selectedParticipantId: null,
            currentCourtId: null,
            isEditMode: false,
            editParticipantId: null,
            openRespDialog: false,
            personType: 1,
            hasPin: true,
            isLegalSearchActive: true,
            pinSearch: "",
            voenSearch: "",
            respForm: {
                pin: "",
                name: "",
                surname: "",
                fatherName: "",
                mobilePhone: "",
                additionalMobilePhone: "",
                gender: "",
                dateOfBirth: "",
                regAddress: "",
                workplace: "",
                tin: "",
                representative: ""
            },
            participants: [],
            courtCases: [],
            activeCollapse: [],
            editCourtDialogVisible: false,
            editableCourtForm: {
                courtId: null,
                judge: "",
                executor: "",
                executorPhone: "",
                demandedAmount: null,
                preCourtExpense: null
            },
            decisionDialogVisible: false,
            decisionForm: {
                courtCaseId: null,
                decisionResult: null,
                decisionDate: "",
                decisionAmount: 0
            },
            loadingHearings: false,
            hearingDialogVisible: false,
            selectedCourtCaseId: null,
            hearingToEdit: null,
            responsibleUserName: null,
            hasCourtReadyParticipants: false,
            expenseDialogVisible: false,
            expenseToEdit: null,
            loadingExpenses: false,
            reasonList: [],
            user: this.$store.state.user.id,
            documentList: [],
            courts: []
        };
    },
    mounted() {
        this.loadCourtsAndCases();
        this.loadResponsiblePerson();
        this.refreshParticipants();
    },
    methods: {
        async askConfirm(text) {
            const res = await this.$swal({
                title: "Təsdiq edin",
                text,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Təsdiq et",
                cancelButtonText: "İmtina",
                customClass: {
                    confirmButton: "btn bg-gradient-info",
                    cancelButton: "btn bg-gradient-secondary",
                },
                buttonsStyling: false,
            });
            return res.isConfirmed === true;
        },
        searchRespPerson() {
            if (this.personType === 1) {
                const match = respPersonData.find(p => p.pin === this.pinSearch);
                if (match) {
                    this.respForm = { ...match };
                    this.pinSearch = "";
                } else {
                    this.$message.warning("FİN tapılmadı");
                }
            } else if (this.personType === 2) {
                const match = respPersonData.find(p => p.tin === this.voenSearch);
                if (match) {
                    this.respForm = { ...match };
                    this.voenSearch = "";
                } else {
                    this.$message.warning("VÖEN tapılmadı");
                }
            }
        },
        async loadSubrogationDocs(courtCaseId) {
            try {
                const resp = await GetSubrogationDocs(this.subrogationId, 0, courtCaseId, 0);
                this.documentList = resp.data || [];
            } catch (e) {
                this.$message.error("Sənədləri yükləmək mümkün olmadı");
            }
        },
        formatAmount(value) {
            if (value == null) return "-";
            let parts = Number(value).toFixed(2).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return parts.join(',');
        },
        openExpenseDialog(courtCaseId) {
            this.resetExpenseForm();
            this.selectedCourtCaseId = courtCaseId;
            this.loadReasonList();
            this.expenseDialogVisible = true;
        },
        editExpense(expense) {
            this.resetExpenseForm();
            this.expenseToEdit = { ...expense };
            this.selectedCourtCaseId = expense.courtCaseId;
            this.loadReasonList();
            this.expenseDialogVisible = true;
        },
        async confirmDeleteExpense(courtCaseId, expenseId) {
            if (!(await this.askConfirm("Silmək istədiyinizə əminsiniz?"))) return;

            this.loadingExpenses = true;
            try {
                await DeleteCourtExpense(expenseId, this.user);
                this.$message.success("Uğurla silindi!");

                const caseItem = this.courtCases.find(c => c.id === courtCaseId);
                if (caseItem) {
                    const res = await GetCourtExpensesByCase(courtCaseId);
                    caseItem.expenses = res.data.data || [];
                }
            } catch {
                this.$message.error("Silinərkən xəta baş verdi");
            } finally {
                this.loadingExpenses = false;
            }
        },

        resetExpenseForm() {
            this.expenseToEdit = null;
            this.selectedCourtCaseId = null;
            this.expenseDialogVisible = false;
        },
        async onExpenseSaved() {
            const courtCaseId = this.selectedCourtCaseId;
            const caseItem = this.courtCases.find(c => c.id === courtCaseId);
            if (!caseItem) return;

            this.loadingExpenses = true;
            try {
                const res = await GetCourtExpensesByCase(courtCaseId);
                caseItem.expenses = res.data.data || [];
            } finally {
                this.loadingExpenses = false;
                this.resetExpenseForm();
            }
        },
        loadReasonList() {
            GetExpenseReasons().then(res => {
                this.reasonList = res.data.data || [];
            });
        },

        async deleteCourtParticipant(participantId, courtCaseId) {
            if (!(await this.askConfirm("Cavabdehi silmək istədiyinizə əminsiniz?"))) return;

            this.loading = true;
            try {
                await DeleteCourtParticipant(participantId, this.user);
                this.$message.success("Uğurlu əməliyyat!");
                const caseItem = this.courtCases.find(c => c.id === courtCaseId);
                if (caseItem) {
                    const res = await GetCourtParticipants(courtCaseId);
                    caseItem.participants = res.data.data || [];
                }
            } catch {
                this.$message.error("Silinmə zamanı xəta");
            } finally {
                this.loading = false;
            }
        },

        refreshParticipants() {
            GetParticipants(this.subrogationId, true)
                .then(res => {
                    this.participants = res.data.data || [];
                    this.hasCourtReadyParticipants = this.participants.length > 0;
                    this.$emit("court-ready", this.hasCourtReadyParticipants);
                })
                .catch(error => {
                    console.error("Ошибка при обновлении участников:", error);
                    this.hasCourtReadyParticipants = false;
                    this.$emit("court-ready", false);
                });
        },
        loadResponsiblePerson() {
            GetSubrogationById(this.subrogationId)
                .then(response => {
                    const respUserId = response.data?.data[0].respUserId;
                    if (respUserId) {
                        const user = respUsers.find(u => u.id === respUserId);
                        this.responsibleUserName = user ? user.name : "(tapılmadı)";
                    } else {
                        this.responsibleUserName = "(tapılmadı)";
                    }
                })
                .catch(error => {
                    console.error("Məsul şəxs alınarkən xəta:", error);
                    this.responsibleUserName = "(tapılmadı)";
                });
        },
        editHearing(hearing) {
            this.selectedCourtCaseId = hearing.courtCaseId;
            this.hearingToEdit = hearing;
            this.hearingDialogVisible = true;
        },
        async confirmDeleteHearing(courtCaseId, hearingId) {
            if (!(await this.askConfirm("Silmək istədiyinizə əminsiniz?"))) return;

            this.loadingHearings = true;
            try {
                await DeleteCourtHearing(hearingId, this.user);
                this.$message.success("Uğurla silindi!");

                const caseItem = this.courtCases.find(c => c.id === courtCaseId);
                if (caseItem) {
                    const res = await GetCourtHearings(courtCaseId);
                    caseItem.hearings = res.data.data || [];
                }
            } catch {
                this.$message.error("Silinərkən xəta baş verdi");
            } finally {
                this.loadingHearings = false;
            }
        },

        getCourtAddressById(id) {
            if (!Array.isArray(this.courts)) return "(tapılmadı)";
            const match = this.courts.find(c => c.id === id);
            return match?.address || "(tapılmayıb)";
        },
        onHearingSaved() {
            this.hearingToEdit = null;
            this.hearingDialogVisible = false;

            const caseItem = this.courtCases.find(c => c.id === this.selectedCourtCaseId);
            if (!caseItem) return;

            this.loadingHearings = true;
            GetCourtHearings(this.selectedCourtCaseId)
                .then(res => {
                    caseItem.hearings = res.data.data || [];
                })
                .finally(() => {
                    this.loadingHearings = false;
                });
        },
        openHearingDialog(courtCaseId) {
            this.selectedCourtCaseId = courtCaseId;
            this.hearingToEdit = null;
            this.hearingDialogVisible = true;
        },
        loadDecision(courtCaseId) {
            GetCourtDecision(courtCaseId)
                .then((response) => {
                    const data = response.data.data[0];
                    if (!data) {
                        this.resetDecisionForm(courtCaseId);
                        return;
                    }

                    this.decisionForm = {
                        id: data.id,
                        courtCaseId: data.courtCaseId,
                        decisionNumber: data.decisionNumber,
                        decisionResult: data.decisionResult,
                        decisionDate: data.decisionDate,
                        decisionAmount: data.decisionAmount
                    };
                })
                .catch((error) => {
                    console.error("Qərar yüklənərkən xəta:", error);
                    this.$message.error("Qərar məlumatları yüklənə bilmədi");
                });
        },
        openDecisionDialog(courtCaseId) {
            this.resetDecisionForm();
            this.decisionDialogVisible = true;
            this.decisionForm.courtCaseId = courtCaseId;
            this.loadDecision(courtCaseId);
        },
        resetDecisionForm(courtCaseId = null) {
            this.decisionForm = {
                courtCaseId: courtCaseId,
                decisionResult: null,
                decisionDate: "",
                decisionAmount: 0
            };
        },
        async saveDecision() {
            try {
                await CreateCourtDecision({
                    ...this.decisionForm,
                    courtCaseId: Number(this.decisionForm.courtCaseId)
                });
                this.$message.success("Uğurlu əməliyyat!");
                this.decisionDialogVisible = false;
                await this.fetchCourtCases();
                this.$emit("saved");
            }
            catch (error) {
                console.error("Xəta:", error);
                this.$message.error("Xəta baş verdi");
            }
        },
        async fetchCourtCases() {
            await this.loadCourtsAndCases();
        },
        resetRespForm() {
            this.respForm = {
                pin: "",
                name: "",
                surname: "",
                fatherName: "",
                mobilePhone: "",
                additionalMobilePhone: "",
                gender: "",
                dateOfBirth: "",
                regAddress: "",
                workplace: "",
                tin: "",
                representative: ""
            };
            this.personType = 1;
            this.hasPin = true;
            this.isLegalSearchActive = true;
            this.pinSearch = "";
            this.voenSearch = "";
            this.editParticipantId = null;
            this.isEditMode = false;
        },
        editParticipant(person, courtCaseId) {
            this.respForm = {
                pin: person.pin || "",
                name: person.name || "",
                surname: person.surname || "",
                fatherName: person.fatherName || "",
                mobilePhone: person.phone || "",
                additionalMobilePhone: person.additionalPhone || "",
                gender: person.gender || "",
                dateOfBirth: person.birthDate || "",
                regAddress: person.regAddress || "",
                workplace: person.workPlace || "",
                tin: person.tin || "",
                representative: person.representative || ""
            };
            this.personType = person.personType;
            this.editParticipantId = person.id;
            this.isEditMode = true;
            this.currentCourtId = courtCaseId;
            this.openRespDialog = true;
        },
        async loadCaseDetails(c) {
            const [
                participantsResponse,
                decisionResponse,
                hearingsResponse,
                enforcementsRes,
                expensesResponse,
                docsRes
            ] = await Promise.all([
                GetCourtParticipants(c.id),
                GetCourtDecision(c.id),
                GetCourtHearings(c.id),
                GetCourtEnforcementsByCourtCase(c.id),
                GetCourtExpensesByCase(c.id),
                GetSubrogationDocs(this.subrogationId, 0, c.id, 0)
            ]);

            return {
                ...c,
                participants: participantsResponse.data.data || [],
                decision: decisionResponse.data.data|| null,
                hearings: hearingsResponse.data.data || [],
                enforcement: (enforcementsRes.data.data && enforcementsRes.data.data.length > 0) ? enforcementsRes.data.data[0] : null,
                expenses: expensesResponse.data.data || [],
                documents: docsRes.data.data || []
            };
        },
        async loadCourtsAndCases() {
            this.loading = true;
            try {
                const [courtsResponse, casesResponse] = await Promise.all([
                    GetCourts(),
                    GetCourtCases(this.subrogationId)
                ]);

                this.courts = courtsResponse.data.data || [];
                const baseCases = (casesResponse.data.data || []).map(c => ({
                    ...c,
                    participants: [],
                    decision: null,
                    hearings: [],
                    expenses: [],
                    documents: [],
                    enforcement: null
                }));

                const detailedCases = await Promise.all(baseCases.map(c => this.loadCaseDetails(c)));
                this.courtCases = detailedCases;

                this.activeCollapse = this.courtCases.map(c => c.id);
            } catch (error) {
                this.$message.error("Xəta baş verdi");
                this.courts = [];
                this.courtCases = [];
            } finally {
                this.loading = false;
            }
        },
        getCourtNameById(id) {
            if (!Array.isArray(this.courts)) return "(tapılmadı)";
            const match = this.courts.find(c => c.id === id);
            return match?.name || "(tapılmadı)";
        },
        DateToString,
        openCourtDialog() {
            this.selectedParticipantId = null;
            this.loadParticipants();
            this.courtDialogVisible = true;
        },
        openAccusedDialog(courtId) {
            this.currentCourtId = courtId;
            this.selectedParticipantId = null;
            this.accusedDialogVisible = true;
            this.refreshParticipants();
        },
        loadParticipants() {
            this.loading = true;
            GetParticipants(this.subrogationId, true)
                .then(res => {
                    this.participants = res.data.data || [];
                })
                .catch(() => {
                    this.$message.error("Cavabdeh şəxsləri yükləmək mümkün olmadı");
                    this.participants = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        updateRespPerson() {
            this.loading = true;
            let payload;

            if (this.personType === 1) {
                payload = {
                    name: this.respForm.name,
                    surname: this.respForm.surname,
                    fatherName: this.respForm.fatherName,
                    pin: this.respForm.pin,
                    personType: 1,
                    gender: this.respForm.gender,
                    birthDate: this.respForm.dateOfBirth,
                    phone: this.respForm.mobilePhone,
                    additionalPhone: this.respForm.additionalMobilePhone,
                    workPlace: this.respForm.workplace,
                    regAddress: this.respForm.regAddress,
                    courtCaseId: Number(this.currentCourtId),
                    subrogationId: this.subrogationId
                };
            } else {
                payload = {
                    name: this.respForm.name,
                    pin: this.respForm.pin,
                    tin: this.respForm.tin,
                    personType: 2,
                    phone: this.respForm.mobilePhone,
                    additionalPhone: this.respForm.additionalMobilePhone,
                    regAddress: this.respForm.regAddress,
                    representative: this.respForm.representative,
                    courtCaseId: Number(this.currentCourtId),
                    subrogationId: this.subrogationId
                };
            }
            const action = this.editParticipantId
                ? UpdateCourtParticipant({ ...payload, id: this.editParticipantId })
                : CreateCourtParticipant(payload);

            action
                .then(() => {
                    this.$message.success("Uğurlu əməliyyat!");
                    this.openRespDialog = false;
                    this.resetRespForm();
                    this.fetchCourtCases();
                })
                .catch(error => {
                    console.error("Xəta:", error);
                    this.$message.error("Məlumat saxlanarkən xəta baş verdi");
                })
                .finally(() => {
                    this.loading = false;
                    this.isEditMode = false;
                    this.editParticipantId = null;
                });
        },
        saveAccused() {
            if (this.selectedParticipantId === 0) {
                this.accusedDialogVisible = false;
                this.resetRespForm();
                this.isEditMode = false;
                this.openRespDialog = true;
                return;
            }

            this.loading = true;

            CreateCourtParticipant({
                participantId: this.selectedParticipantId,
                courtCaseId: this.currentCourtId,
                user: this.user
            })
                .then(() => {
                    this.$message.success("Uğurlu əməliyyat!");
                    this.accusedDialogVisible = false;
                    const caseItem = this.courtCases.find(c => c.id === this.currentCourtId);
                    if (caseItem) {
                        GetCourtParticipants(this.currentCourtId).then(res => {
                            caseItem.participants = res.data.data || [];
                        });
                    }
                    this.selectedParticipantId = null;
                    this.currentCourtId = null;
                })
                .catch(error => {
                    console.error("Xəta:", error);
                    this.$message.error("İttiham olunan əlavə edilə bilmədi");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        editCourt(caseItem) {
            this.editableCourtForm = {
                id: caseItem.id,
                courtId: caseItem.courtId,
                judge: caseItem.judge,
                executor: caseItem.executor,
                executorPhone: caseItem.executorPhone || "", // 👈 добавлено
                preCourtExpense: caseItem.preCourtExpense,
                demandedAmount: caseItem.demandedAmount
            };
            this.editCourtDialogVisible = true;
        },
        async saveCourtEdit() {
            const f = this.editableCourtForm;

            const phone = (f.executorPhone || "").trim();
            const phoneValid = /^\+994\s?\(\d{2}\)\s?\d{3}-\d{2}-\d{2}$/.test(phone);

            const isInvalid =
                !f.courtId ||
                !f.judge?.trim() ||
                !f.executor?.trim() ||
                !phone || !phoneValid ||
                f.preCourtExpense == null || f.preCourtExpense <= 0 ||
                f.demandedAmount == null || f.demandedAmount <= 0;

            if (isInvalid) {
                this.$message.warning("Zəhmət olmasa bütün sahələri düzgün doldurun.");
                return;
            }

            this.loading = true;
            try {
                await UpdateCourtCase({
                    id: f.id,
                    courtId: f.courtId,
                    judge: f.judge.trim(),
                    executor: f.executor.trim(),
                    executorPhone: phone,
                    preCourtExpense: f.preCourtExpense,
                    demandedAmount: f.demandedAmount,
                    user: this.user
                });

                this.$message.success("Uğurlu əməliyyat!");
                this.editCourtDialogVisible = false;
                await this.loadCourtsAndCases();
            } catch (e) {
                console.error("UpdateCourtCase error:", e);
                this.$message.error("Yeniləmə zamanı xəta baş verdi");
            } finally {
                this.loading = false;
            }
        }

    },
};
</script>
<style scoped>
.card {
    box-shadow: none;
}

.col-8 {
    color: #222222;
}

.doc-header-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;
}
</style>